
import { Component, Mixins } from "vue-property-decorator";
import BoxHotel from "@/mixins/BoxHotel";

@Component
export default class BoxArchivesHotelJa extends Mixins(BoxHotel) {
  protected words: Dictionary = {
    address: "住所",
    access: "交通",
    btOfficialSite: "公式ホームページ",
    btReserve: "", // 初期値
  };

  created() {
    const isSubscriber12 = this.$store.getters["auth/group"] === "subscriber12";

    const isTokyodome = this.datas && this.datas.htl_id === "tokyodome";

    this.words.btReserve =
      isSubscriber12 && isTokyodome
        ? "予約する（一般）"
        : "予約する（法人優待）";
  }
}
